import React from 'react';
import { useField } from 'formik';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';

const FormikInput = ({
  label,
  type = 'text',
  name,
  options = [],
  placeholder,
  disabled = false, // prop para deshabilitar desde el formulario
  ...rest
}) => {
  const [field, meta] = useField(name);

  const hasError = meta.touched && meta.error;

  return (
    <FormGroup>
      {label && <Label for={name}>{label}</Label>}

      {type === 'select' ? (
        <Input
          type="select"
          id={name}
          {...field}
          invalid={!!hasError}
          disabled={disabled} // deshabilitado si viene prop
          {...rest}
        >
          {options.map((opt, index) => (
            <option key={index} value={opt.value ?? opt}>
              {opt.label ?? opt}
            </option>
          ))}
        </Input>
      ) : type === 'textarea' ? (
        <Input
          type="textarea"
          id={name}
          {...field}
          placeholder={placeholder}
          invalid={!!hasError}
          disabled={disabled}
          {...rest}
        />
      ) : (
        <Input
          type={type}
          id={name}
          {...field}
          placeholder={placeholder}
          invalid={!!hasError}
          disabled={disabled}
          {...rest}
        />
      )}

      {hasError && <FormFeedback>{meta.error}</FormFeedback>}
    </FormGroup>
  );
};

FormikInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FormikInput;
